var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SunwayCkeditor',{ref:"editor",attrs:{"dataId":_vm.dataId,"value":_vm.propValue,"config":_vm.config,"readonly":_vm.readonly,"globalExtraPlugins":_vm.globalExtraPlugins},on:{"change":_vm.changeHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }